export default "<p>project-details-risk works!</p>\n";